/* eslint-disable no-constant-condition */
import {
  GET_REGION_RESULTS_REQUEST,
  GET_REGION_RESULTS_SUCCESS,
  GET_REGION_RESULTS_FAIL,
  PROMO_CODE_VALIDATION
} from "../constants/actionTypes";
import { getRegionResults as regionResultsFromApi } from "../api/regions";

import { generateAsyncAction } from "./generateAsyncAction";

export const getRegionResults = request => async dispatch => {
  dispatch({ type: GET_REGION_RESULTS_REQUEST });
  const getRegionResultAction = await generateAsyncAction({
    onFailAction: regionResultFailed,
    onSuccessAction: regionResultSuccess,
    asyncApiMethod: regionResultsFromApi,
    request
  });
  return dispatch(getRegionResultAction);
};

const regionResultSuccess = ({ payload }) => dispatch => {
  dispatch(regionDataSuccess(payload));
  dispatch(promoCodeValidation(payload));
};

const regionDataSuccess = payload => ({
  type: GET_REGION_RESULTS_SUCCESS,
  payload: payload && payload.regions
});

const promoCodeValidation = payload => ({
  type: PROMO_CODE_VALIDATION,
  payload: payload.isPromoCodeValid
});

const regionResultFailed = ({ message, title }) => ({
  type: GET_REGION_RESULTS_FAIL,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});

// export const selectHotel = (hotelId) => async (dispatch, getState) => {
//     // const { pax } = getState();
//     // const selectedSessions = pax.map(pax => {
//     //     return pax.rateId;
//     // });

//    // redirectToHotelSearchResultsPage(selectedSessions, hotelId); // for now we will just redirect the location

//    // history.pushState('/hotel/'+hotelId); **********
// };



// WEBPACK FOOTER //
// ./src/actions/regionResultsActions.js